/** **************************** Import Types ****************************** */
import { NOTES_REQUEST, NOTES_SUCCESS, NOTES_FAILURE } from "../types/notes.types";

const initialState = {
  storeItemResponse: "",
  error: "",
  loading: false,
};

const NotesReducer = (state = initialState, action) => {

  switch (action.type) {
    case NOTES_REQUEST:
      return {
        ...state,
        storeItemResponse: action.payload || "",
        loading: true,
      };
    case NOTES_SUCCESS:
      return {
        ...state,
        storeItemResponse: action.payload,
        loading: false,
      };
    case NOTES_FAILURE:
      return {
        ...state,
        storeItemResponse:action.payload,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};

export default NotesReducer;
